var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { QuiButton, getButtonClassName } from "../QuiButton/QuiButton.js";
import { WithIcon, fieldSizeToIconSize } from "../_primitives/WithIcon.js";
export const QuiButtonExternalLink = forwardRef((_a, ref) => {
    var { iconLeft, iconRight, variant, size, className, style, children, openInNewTab, disabled } = _a, otherProps = __rest(_a, ["iconLeft", "iconRight", "variant", "size", "className", "style", "children", "openInNewTab", "disabled"]);
    const iconProps = { iconLeft, iconRight, iconSize: fieldSizeToIconSize(size) };
    const buttonClassName = getButtonClassName({ variant, size, children, iconLeft, iconRight, className });
    const additionalProps = {};
    if (openInNewTab) {
        additionalProps.target = "_blank";
        additionalProps.rel = "noopener noreferrer";
    }
    if (disabled) {
        const disabledButtonProps = {};
        if ("data-test" in otherProps) {
            disabledButtonProps["data-test"] = otherProps["data-test"];
        }
        return (React.createElement(QuiButton, Object.assign({ disabled: true, iconLeft: iconLeft, iconRight: iconRight, variant: variant, size: size, className: className, style: style }, disabledButtonProps), children));
    }
    return (React.createElement("a", Object.assign({ ref: ref, className: buttonClassName, style: style }, otherProps, additionalProps),
        React.createElement(WithIcon, Object.assign({}, iconProps), children)));
});
QuiButtonExternalLink.displayName = "QuiButtonExternalLink";
